// src/pages/letters/LettersSkeleton.jsx
import React from "react";

const SkeletonItem = () => (
  <div className="list-item">
    <div style={{ flex: 1 }}>
      <div
        className="skeleton skeleton-line"
        style={{ width: "50%", marginBottom: 10 }}
      />
      <div className="skeleton skeleton-line" style={{ width: "35%" }} />
    </div>
    <div style={{ display: "flex", gap: 6 }}>
      <div className="skeleton skeleton-btn-sm" />
      <div className="skeleton skeleton-btn-sm" />
      <div className="skeleton skeleton-btn-sm" />
    </div>
  </div>
);

export default function LettersSkeleton() {
  return (
    <div className="card">
      <div className="card-header-row">
        <div className="skeleton skeleton-title" style={{ margin: 0, width: 120 }} />
        <div className="skeleton skeleton-btn" />
      </div>

      <div className="lt-search">
        <div className="skeleton skeleton-input" style={{ height: 44 }} />
      </div>

      {[1, 2, 3, 4, 5].map((i) => (
        <SkeletonItem key={i} />
      ))}

      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--border-strong) 50%,
            var(--border) 75%
          );
          background-size: 200% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 8px;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .skeleton-line {
          height: 14px;
        }
        .skeleton-title {
          height: 22px;
        }
        .skeleton-input {
          width: 100%;
          border-radius: 10px;
        }
        .skeleton-btn {
          height: 44px;
          width: 150px;
          border-radius: 12px;
        }
        .skeleton-btn-sm {
          height: 32px;
          width: 72px;
          border-radius: 9px;
        }
      `}</style>
    </div>
  );
}